/**
 * See the NOTICE file distributed with this work for additional information
 * regarding copyright ownership.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { gql } from 'graphql-request';

type Params = {
  genomeId: string;
  geneId: string;
};

const transcriptFieldsFragment = gql`
  fragment transcriptFields on Transcript {
    stable_id
    slice {
      location {
        length
      }
    }
    product_generating_contexts {
      product_type
    }
    metadata {
      biotype {
        label
        value
      }
      canonical {
        value
        label
      }
      mane {
        value
        label
        ncbi_transcript {
          id
          url
        }
      }
    }
  }
`;

const trackPanelGeneQuery = (params: Params) => gql`
  query TrackPanelGene {
    gene(by_id: { genome_id: "${params.genomeId}", stable_id: "${params.geneId}" }) {
      stable_id
      unversioned_stable_id
      symbol
      slice {
        region {
          name
        }
        location {
          start
          end
        }
        strand {
          code
        }
      }
      metadata {
        biotype {
          label
        }
      }
      transcripts_page(page: 1, per_page: 100) {
        transcripts {
          ...transcriptFields
        }
      }
    }
  }
  ${transcriptFieldsFragment}
`;

export default trackPanelGeneQuery;
